<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 22 22"
    fill="none"
  >
    <rect
      x="0.667969"
      y="0.5"
      width="20.664"
      height="20.664"
      rx="10.332"
      stroke="#213E7A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5998 6.6696L9.13674 12.907L7.42168 11.0746C7.10574 10.7767 6.60928 10.7587 6.24821 11.0114C5.89617 11.2732 5.79688 11.7336 6.01352 12.1037L8.04452 15.4074C8.2431 15.7143 8.58612 15.9039 8.97426 15.9039C9.34436 15.9039 9.6964 15.7143 9.89498 15.4074C10.2199 14.9832 16.4213 7.59032 16.4213 7.59032C17.2337 6.75987 16.2498 6.02871 15.5998 6.66057V6.6696Z"
      fill="#213F7A"
    />
  </svg>
</template>

<script>
export default {
  name: "IconStepperDone",
};
</script>

<style></style>
